import React, { useRef } from 'react';
import { Form, InputGroup } from 'react-bootstrap';

const ImageUpload = ({ onFileSelect }) => {
  const fileInputRef = useRef();

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    onFileSelect(file);
  };

  const handleFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    onFileSelect(file);
  };

  const handleDropzoneClick = () => {
    fileInputRef.current.click();
  };

  return (
    <Form className="d-flex flex-column justify-content-center" style={{height:'130px'}}>
      <Form.Group
        controlId="formFile"
        onDrop={handleFileDrop}
        onDragOver={(e) => e.preventDefault()}
        className="cursor-pointer h-100 w-100 d-flex flex-column justify-content-center">
        <div className="fw-light text-end">
          <div className="h-100 d-flex flex-column">
            <p className="m-0 p-0" onClick={handleDropzoneClick}>
              <a className="fw-bold text-reset" href="#">
                Click to upload
              </a>{' '}
              or Drag and drop an image{' '}
            </p>
            <p className="m-0 p-0 fw-light">
              You can upload a JPG, GIF, or PNG file. The maximum file size is 3MB
            </p>
          </div>
        </div>
        <InputGroup>
          <Form.Control
            type="file"
            accept=".jpg, .jpeg, .png, .gif"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </InputGroup>
      </Form.Group>
    </Form>
  );
};

export default ImageUpload;
